import { VersionContext } from '@apps/Application/Application'
import { useTranslate } from '@common/hooks'
import { getButtonText, getDisabledStatus } from '@common/utils/settingsFormSubmitButton'
import Button from '@common/widgets/Button'
import { useContext, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

interface IProps {
  application: IApplication,
  settings: IApplicationSettingKeyed[],
  permissions: IPermissionKeyed[],
  className?: string,
  [key: string]: any,
}

function SubmitButton({ application, settings, permissions, ...props }: IProps): JSX.Element {
  const { formState: { dirtyFields } } = useFormContext()
  const { translate } = useTranslate()
  const { version, versionSelectorHasAccess } = useContext(VersionContext)

  const isDirty = Object.values(dirtyFields).some(field => Boolean(field))
  const buttonText = useMemo(() => getButtonText(translate, application, versionSelectorHasAccess ? version : ''), [application, version, versionSelectorHasAccess])

  return (
    <Button
      disabled={getDisabledStatus(application, settings, permissions, isDirty, version)}
      {...props}>
      {buttonText}
    </Button>
  )
}

SubmitButton.defaultProps = {
  className: undefined,
}

export default SubmitButton
